
function isDiscountNOK(repo: { langCode: string }, currency: string): boolean {
  const startDate = Date.UTC(2026, 4, 10, 22, 0, 0); // May 11 00:00 CEST (UTC+2)
  const endDate = Date.UTC(2026, 5, 20, 1, 59, 59);  // Jun 19 23:59 CEST (UTC+2)
  const now = Date.now();
  return repo.langCode === "no" && now >= startDate && now < endDate && currency === 'NOK';
}

// Prices for DKK are fetched live from uCommerce. TILBUD is set when salePrice < listPrice.
function isDiscountDKK(repo: { langCode: string }, currency: string): boolean {
  return repo.langCode === 'da' && currency === 'DKK';
}

export function isDiscount(repo: { langCode: string }, currency: string): boolean {
  return isDiscountNOK(repo, currency) || isDiscountDKK(repo, currency);
}

export function getDiscountPriceKey(repo: { langCode: string }, currency: string): string | null {
  if (isDiscountNOK(repo, currency)) return 'TILBUD_NOK';
  if (isDiscountDKK(repo, currency)) return 'TILBUD';
  return null;
}
